"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const redoc_1 = require("redoc");
const ui_1 = require("@phishtool/ui");
const react_1 = require("react");
const styled_1 = require("./styled");
const use_expandable_tags_1 = require("./use-expandable-tags");
const useFAB = () => {
    const menuSelector = '.menu-content';
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const menu = document.querySelector(menuSelector);
        menu === null || menu === void 0 ? void 0 : menu.classList.toggle('is-open', isOpen);
    }, [isOpen]);
    return [isOpen, setIsOpen];
};
const Home = () => {
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const [isOpen, setIsOpen] = useFAB();
    const specUrl = `/spec.json`;
    (0, use_expandable_tags_1.useExpandableTags)(isLoaded);
    (0, react_1.useEffect)(() => {
        document.body.classList.add('redoc');
        return () => {
            document.body.classList.remove('redoc');
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "redoc-content", children: [(0, jsx_runtime_1.jsx)(styled_1.StyledSubNavHeading, { isSubNavOpen: isOpen, children: "API Documentation" }), (0, jsx_runtime_1.jsx)(redoc_1.RedocStandalone, { specUrl: specUrl, onLoaded: () => setIsLoaded(true), options: {
                    hideFab: true,
                    showWebhookVerb: true,
                    showObjectSchemaExamples: true,
                    disableSearch: true,
                    hideDownloadButton: true,
                    sortPropsAlphabetically: true,
                    scrollYOffset: 54,
                    theme: {
                        breakpoints: {
                            small: `${ui_1.smallBreakpoint - 1}px`,
                            medium: `${ui_1.mediumBreakpoint - 1}px`,
                            large: `${ui_1.largeBreakpoint - 1}px`,
                        },
                        spacing: {
                            unit: 6,
                            sectionHorizontal: ({ spacing }) => spacing.unit * 6,
                            sectionVertical: ({ spacing }) => spacing.unit * 3,
                        },
                        colors: {
                            text: {
                                primary: ui_1.oxfordBlue,
                                secondary: ui_1.oxfordBlue,
                            },
                            primary: {
                                main: ui_1.celticBlue,
                            },
                            success: {
                                main: ui_1.appleGreen,
                            },
                            warning: {
                                main: ui_1.orangeYellow,
                            },
                            error: {
                                main: ui_1.madderLake,
                            },
                            responses: {
                                success: {
                                    color: ui_1.darkMoss,
                                    backgroundColor: (0, ui_1.hexToRgba)(ui_1.peppermint, 0.4),
                                    tabTextColor: ({ colors }) => colors.responses.success.color,
                                },
                                error: {
                                    color: ui_1.madderLake,
                                    backgroundColor: (0, ui_1.hexToRgba)(ui_1.tutu, 0.4),
                                    tabTextColor: ({ colors }) => colors.responses.error.color,
                                },
                            },
                        },
                        typography: {
                            fontFamily: ui_1.primaryFont,
                            headings: {
                                fontFamily: ui_1.primaryFont,
                            },
                            code: {
                                fontSize: '13px',
                                fontFamily: ui_1.monospaceFont,
                                backgroundColor: 'transparent',
                                color: ui_1.heroOrange,
                            },
                        },
                        sidebar: {
                            width: '252px',
                            backgroundColor: ui_1.white,
                            textColor: ui_1.oxfordBlue,
                            groupItems: {
                                activeBackgroundColor: ui_1.cultured,
                            },
                            level1Items: {
                                activeBackgroundColor: ui_1.cultured,
                            },
                            arrow: {
                                size: '0px',
                            },
                        },
                        rightPanel: {
                            backgroundColor: ui_1.white,
                        },
                        codeBlock: {
                            backgroundColor: ui_1.oxfordBlue,
                        },
                    },
                } }), (0, jsx_runtime_1.jsx)(ui_1.FAB, { isOpen: isOpen, setIsOpen: setIsOpen })] }));
};
exports.default = Home;
